import * as React from "react";
import { Actions, SideLink } from "@twilio/flex-ui/";
import uhaulStore from "../CustomRedux/UhaulStore";
import { updateSelectedCannedMessageQueue, updateCannedMessageQueues } from "./Actions/SettingsActions";
import { updateCannedMessages } from "./Actions/CannedResponsesActions";
import ExceptionLogger from "../ExceptionHelper";
import { CannedMessageEditor } from "./CannedMessageEditor";
import { Box, Label, Select, Option, Table, THead, TBody, Th, Tr } from "@twilio/flex-ui/node_modules/@twilio-paste/core";
import GetLiveChatHeader from "../LiveChatHeaderHelper";

export class ManageSettingsButton extends React.Component {

    render() {
        return <SideLink
            {...this.props}
            icon="Settings"
            isActive={this.props.activeView === "manage-settings-page"}
            onClick={() => Actions.invokeAction("NavigateToView", { viewName: "manage-settings-page" })}>Manage Settings</SideLink>
            ;
    }
}

export class ManageSettingsPage extends React.Component {
    constructor(props) {
        super(props);

        const UhaulReducer = uhaulStore.getState().UhaulReducer;
        this.state = {
            loading: true,
            cannedMessages: UhaulReducer.cannedMessages || [],
            cannedMessageQueues: UhaulReducer.cannedMessageQueues || [],
            selectedQueueId: UhaulReducer.cannedMessageQueues && UhaulReducer.cannedMessageQueues.length > 0
                ? UhaulReducer.cannedMessageQueues[0].Id
                : null
        }
        this.handleQueueChange = this.handleQueueChange.bind(this);
        this.handleCannedMessagesSubmit = this.handleCannedMessagesSubmit.bind(this);
        this.handleCannedMessagesDelete = this.handleCannedMessagesDelete.bind(this);
        this.setSelectedQueue = this.setSelectedQueue.bind(this);
        this.postServiceUrl = uhaulStore.getState().UhaulReducer.config.liveChatApiUrl;

        this.getAllQueues();
        this.getAllMessages();
    }

    getAllQueues = () => {
        const requestUri = this.postServiceUrl + "Queues";
        fetch(requestUri,
                {
                    method: "GET",
                    headers: GetLiveChatHeader() 
                })
            .then(response => response.json())
            .then(json => {
                if (!json.Success || !json.Data) {
                    var errorMessage = json.Errors ? json.Errors.join("\n") : "Unknown error.";
                    console.log(errorMessage);
                    return;
                }
                var currentUser = uhaulStore.getState().UhaulReducer.currentUser;
                var queues = json.Data.filter((queue) => {
                    if (!currentUser || !currentUser.queues || !Array.isArray(currentUser.queues)) {
                        return false;
                    }
                    return currentUser.queues.some((userQueue) => {
                        return userQueue.toLowerCase() === queue.Type.toLowerCase();
                    });
                });
                const selectedQueueId = queues?.[0]?.Id ?? null;
                uhaulStore.dispatch(updateCannedMessageQueues(queues));
                this.setState({
                    loading: false,
                    cannedMessageQueues: queues,
                    selectedQueueId: selectedQueueId
                });
            })
            .catch((error) => {
                ExceptionLogger(error, "CannedMessages.getAllQueues");
                this.setState({ loading: false });
            });
    }

    getAllMessages = () => {
        const requestUri = this.postServiceUrl + "CannedMessages";
        fetch(requestUri,
            {
                method: "GET",
                headers: GetLiveChatHeader()
            })
            .then(response => response.json())
            .then(json => {
                if (!json.Success || !json.Data) {
                    const errorMessage = json.Errors ? json.Errors.join(" | ") : "Unknown error.";
                    ExceptionLogger(errorMessage, "CannedMessages.getAllMessages", errorMessage);
                    return;
                }
                const messages = json.Data;
                uhaulStore.dispatch(updateCannedMessages(messages));
                this.setState({ cannedMessages: messages });
            })
            .catch(error => {
                ExceptionLogger(error, "CannedMessages.getAllMessages", "Error with fetching Canned Messages.");
                this.setState({ loading: false });
            });
    }

    handleCannedMessagesSubmit = (cannedMessage) => {
        const index = this.state.cannedMessages.findIndex(x => x.Id.toLowerCase() === cannedMessage.Id.toLowerCase());
        const isNew = index < 0;
        let updatedMessages;
        
        if (isNew) {
            updatedMessages = [...this.state.cannedMessages, cannedMessage];
        } else {
            // Create a new array with the modified canned message
            updatedMessages = [
                ...this.state.cannedMessages.slice(0, index),
                cannedMessage,
                ...this.state.cannedMessages.slice(index + 1)
            ];
        }
        
        this.setState({ cannedMessages: updatedMessages });
        uhaulStore.dispatch(updateCannedMessages(updatedMessages));
    }

    handleCannedMessagesDelete = (id) => {
        const remainingMessages = this.state.cannedMessages.filter(x => x.Id.toLowerCase() !== id.toLowerCase());
        this.setState({ cannedMessages: remainingMessages });
        uhaulStore.dispatch(updateCannedMessages(remainingMessages));
    }

    handleQueueChange = (event) => {
        this.setSelectedQueue(event.target.value);
    }

    setSelectedQueue = (queueId) => {
        if (this.state.selectedQueueId != null && this.state.selectedQueueId === queueId) return;

        uhaulStore.dispatch(updateSelectedCannedMessageQueue({ "selectedCannedMessageQueue": queueId }));
        this.setState({ selectedQueueId: queueId });
    }

    render() {
        var taskContexts = uhaulStore.getState().UhaulReducer.currentTaskContext;

        if (!this.props.isViewActive) {
            return null;
        }
        else if (this.state.loading || Object.keys(this.state.cannedMessages).length === 0 || Object.keys(this.state.cannedMessageQueues).length === 0) {
            return (<Box className="loadingSettings">Loading...</Box>);
        }
        else if (!taskContexts) {
            return (<Box className="waitingSettings"></Box>);
        }

        const selectedCannedMessages = this.state.cannedMessages
            .filter(function (cannedMessage) {
                return cannedMessage.QueueId === this.state.selectedQueueId;
            }, this);

        // Add empty row for adding new.
        selectedCannedMessages.push({
            Id: null,
            QueueId: this.state.selectedQueueId,
            Title: '',
            Description: ''
        });

        return (
            <Box className="manage-canned-messages">
                <Label as="h2" htmlFor="messageQueues" className="TitleEnlarged">Manage Canned Messages</Label>
                <Select id="messageQueues" key="messageQueues" defaultValue={this.state.selectedQueueId.toString()} onChange={this.handleQueueChange}>
                    {
                        this.state.cannedMessageQueues.map(function (queue) {
                            return <Option key={queue.Id} value={queue.Id}>{queue.Name}</Option>;
                        }, this)
                    }
                </Select>
                <br />
                <Table className="queue-canned-messages">
                    <THead>
                        <Tr>
                            <Th>Title</Th>
                            <Th>Description</Th>
                            <Th>Actions</Th>
                        </Tr>
                    </THead>
                    <TBody>
                        {
                            selectedCannedMessages
                                .filter(function (cannedMessage) {
                                    return cannedMessage.QueueId === this.state.selectedQueueId;
                                }, this)
                                .map(function (cannedMessage) {
                                    return <CannedMessageEditor
                                        handleCannedMessagesSubmit={this.handleCannedMessagesSubmit}
                                        handleCannedMessagesDelete={this.handleCannedMessagesDelete}
                                        postServiceUrl={this.postServiceUrl}
                                        viewModel={cannedMessage} key={cannedMessage.QueueId.toString() + "_" + (cannedMessage.Id || "new").toString()} />;
                                }, this)
                        }
                    </TBody>
                </Table>
            </Box>
        );
    }
}
